import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";

const IconTwitch = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.99 0L1.7 4.286v15.428h5.147V24l4.29-4.286h3.431L22.29 12V0H5.99zm14.583 11.143l-3.431 3.428H13.71l-3.002 3v-3h-3.86V1.714h13.725v9.429z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.714h-1.716v5.143H18V4.714zm-4.719 0h-1.715v5.143h1.715V4.714z"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(IconTwitch, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;